import { render, staticRenderFns } from "./PraticasTeoricasHoje.vue?vue&type=template&id=677e0e50"
import script from "./PraticasTeoricasHoje.vue?vue&type=script&lang=js"
export * from "./PraticasTeoricasHoje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports